var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-container" },
    [
      _vm.homeType === "normal" && !this.isNewCh() ? _c("home") : _vm._e(),
      _vm._v(" "),
      ["salesLeader_home", "asm_rsm_home", "sa_da_training_home"].includes(
        _vm.homeType
      )
        ? _c("home-asm-rsm")
        : _vm._e(),
      _vm._v(" "),
      _vm.functions["chatbot"]
        ? _c("div", { staticClass: "chatbot-button" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isMenuVisible,
                    expression: "!isMenuVisible",
                  },
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "avatar-img", on: { click: _vm.goChatbot } },
                  [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        src: require("@/assets/chatbot/chatbotIcon-ai.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMenuVisible,
                    expression: "isMenuVisible",
                  },
                ],
                staticClass: "el-overlay",
                on: { click: _vm.toggleMenu },
              },
              [
                _c(
                  "div",
                  { staticClass: "menu" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            path: "/chatbotModule/chatbot",
                            query: { knowledgeType: "1" },
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "menu-item" }, [
                          _c("div", { staticClass: "menu-img" }, [
                            _c("img", {
                              staticClass: "img",
                              attrs: {
                                src: require("@/assets/chatbot/chatbotIcon-knowledge.png"),
                                alt: "",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("Chatbot.Chatbot_knowledge_base"))
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            path: "/chatbotModule/chatbot",
                            query: { knowledgeType: "2" },
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "menu-item" }, [
                          _c("div", { staticClass: "menu-img" }, [
                            _c("img", {
                              staticClass: "img",
                              attrs: {
                                src: require("@/assets/chatbot/chatbotIcon-analysis.png"),
                                alt: "",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "menu-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Chatbot.Chatbot_behavior_analysis")
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }